import { Wrapper } from './InnerPageWrapper.styled'

const InnerPageWrapper = ({ children }) => {
  return <Wrapper>{children}</Wrapper>
}

export default InnerPageWrapper
